// Fixed color per sales channel, reused by the legend and the stacked bar chart so
// both always paint a channel the same way. Keys match CirChannelSliceDto['channel'].
type ChannelName = 'Offline' | 'Online (MBGo)' | 'GrabFood' | 'Foodpanda' | 'Other';

export const CHANNEL_ORDER: ChannelName[] = ['Offline', 'Online (MBGo)', 'GrabFood', 'Foodpanda', 'Other'];

const CHANNEL_COLORS: Record<ChannelName, string> = {
  Offline: '#8149F3',
  'Online (MBGo)': '#D25DE9',
  GrabFood: '#61AAE3',
  Foodpanda: '#5DDACF',
  Other: '#C2C5D6',
};

const DEFAULT_COLOR = '#C2C5D6';

export function getChannelColor(channel: string): string {
  return CHANNEL_COLORS[channel as ChannelName] ?? DEFAULT_COLOR;
}

// Readable text color for a label drawn on top of the channel's fill.
export function getChannelTextColor(channel: string): string {
  const hex = getChannelColor(channel);
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return luminance > 0.6 ? '#0f172b' : '#ffffff';
}
